export default "__VITE_ASSET__440bb665__"